module.exports = __webpack_public_path__ + "static/media/HomeStoryImage6.c19ac6e6.jpg";